import {Injectable} from "@angular/core";

/**
 * Storage of large values, such as products in the comparator, cart, or saved products to generate a PDF.
 * Note that these values will not be available on the server when performing Server Side Rendering (SSR).
 */
@Injectable()
export abstract class LargeStorageLocal {

    public abstract getItem(key: string): string | null;

    public abstract setItem(key: string, value: string): void;

    public abstract removeItem(key: string): void;

    public abstract clear(): void;

}
